export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-primary-500 flex items-center justify-center">
            <i className="ri-movie-2-line text-background-50 text-2xl" style={{ width: '1em', height: '1em' }}></i>
          </div>
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">关于6080影视</h2>
          <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-4">
            <p>
              <strong className="text-foreground-900">6080影视</strong>诞生于动漫爱好者的共同愿景——让每一位追番人都能享受到<strong className="text-foreground-900">免费、高清、不缓冲</strong>的极致观影体验。
            </p>
            <p>
              平台汇聚<strong className="text-primary-500">10000+部</strong>动漫资源，覆盖日漫、国漫、经典番剧等多个分类。从热血战斗到治愈日常，从悬疑推理到恋爱喜剧，
              无论你喜欢什么类型，都能在这里找到心头好。我们采用先进的<strong className="text-foreground-900">智能CDN加速</strong>与<strong className="text-foreground-900">1080P高清片源</strong>，
              确保每一帧画面都清晰流畅，彻底告别令人抓狂的缓冲转圈。
            </p>
            <p>
              每周同步更新<strong className="text-accent-500">50+部</strong>最新番剧，第一时间为动漫迷送上当季热门作品。
              6080影视坚持<strong className="text-foreground-900">完全免费</strong>，无需注册登录即可直接观看，为动漫爱好者打造最纯粹的高清动漫在线观看平台。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}